import { IonContent } from "@ionic/react";
import { useTranslate } from "../contexts/translate";
import { Background } from "../components/ui/Background";
import { PaperBackground } from "../components/ui/PaperBackground";
import { BigButton } from "../components/ui/BigButton";
import { CategoryButton } from "../components/ui/CategoryButton";
import { CategoryType } from "../components/CategorySubheader";
import { Subheader } from "../components/ui/Subheader";
import styled from "styled-components";
import { Header } from "../components/ui/Header";

export const categories: CategoryType[] = [
  "terrains",
  "actions",
  "troops",
  "nations",
  "swas",
];

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: calc(2 * var(--u));
  width: calc(80 * var(--u));

  @media (orientation: landscape) {
    width: 94vw;
    margin: auto;
  }
`;

export function Cards() {
  const { translate } = useTranslate();

  return (
    <>
      <Header size="small" shouldHide />
      <IonContent>
        <Background background="cards">
          <Subheader>
            <BigButton
              icon="cards"
              label={translate("screens.cards.title")}
              to=""
              mode="title"
            />
          </Subheader>
          <IonContent style={{ "--background": "transparent" }}>
            <PaperBackground>
              <Container>
                {categories.map((category) => (
                  <CategoryButton
                    key={category}
                    icon={category}
                    label={translate(`screens.cards.${category}`)}
                    to={`/cards/${category}`}
                  />
                ))}
              </Container>
            </PaperBackground>
          </IonContent>
        </Background>
      </IonContent>
    </>
  );
}
